import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { translatedTitle } from '@core/i18n/translated-title';

export const routes: Routes = [
    {
        path: 'MdlWebClient',
        component: MsalRedirectComponent
    },
    {
        path: '',
        loadComponent: () => import('./layout').then(m => m.DefaultLayoutComponent),
        title: translatedTitle('appRoutes.homeTitle'),
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./views/dashboard/routes').then(m => m.routes),
                canActivate: [MsalGuard]
            },
            {
                path: 'upload-wizard',
                loadChildren: () =>
                    import('@features/upload-process-wizard/upload-process-wizard.routes').then(
                        m => m.UPLOAD_PROCESS_WIZARD_ROUTES
                    ),
                canActivate: [MsalGuard]
            },
            {
                path: 'settings',
                loadChildren: () => import('./features/settings/views/routes').then(m => m.routes),
                canActivate: [MsalGuard]
            }
        ]
    },
    { path: '**', redirectTo: 'dashboard' }
];
